import Vue from 'vue';
import Vuex from 'vuex';
import search from './search';
import comments from './comments';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        search,
        comments,
    },
    state: {
        showDepartmentDropdown: false,
        showUserDropdown: false,
        showRemoteMenu: false,
        showSearchOverlay: false,
        showMobileDepartmentsMenu: false,
        user: {},
    },

    mutations: {
        toggleDepartmentDropdown(state) {
            state.showDepartmentDropdown = !state.showDepartmentDropdown;
        },
        toggleUserDropdown(state) {
            state.showUserDropdown = !state.showUserDropdown;
        },
        toggleRemoteMenu(state) {
            state.showRemoteMenu = !state.showRemoteMenu;
        },
        toggleMobileDepartmentsMenu(state) {
            state.showMobileDepartmentsMenu = !state.showMobileDepartmentsMenu;
        },
        toggleSearchOverlay(state) {
            state.showSearchOverlay = !state.showSearchOverlay;
        },
        setUser(state, user) {
            state.user = user;
        },
        setAvatar(state, avatar) {
            state.user.avatar = avatar;
        },
    },

    actions: {
        toggleDepartmentDropdown({ commit }) {
            commit('toggleDepartmentDropdown');
        },
        toggleUserDropdown({ commit }) {
            commit('toggleUserDropdown');
        },
        toggleRemoteMenu({ commit }) {
            commit('toggleRemoteMenu');
        },
        toggleSearchOverlay({ commit }) {
            commit('toggleSearchOverlay');
        },
        toggleMobileDepartmentsMenu({ commit }) {
            commit('toggleMobileDepartmentsMenu');
        },
        setUser({ commit }, user) {
            commit('setUser', user);
        },
        setAvatar({ commit }, avatar) {
            commit('setAvatar', avatar);
        },
    },
});

export default store;
